import PropTypes from 'prop-types';
import { NumericInput } from '@evertrue/et-components';

const CustomLongField = ({ value, customField = {}, handleChange = () => {}, handleTouched = () => {} }) => {
  return (
    <div className="interaction-custom-fields-form--small-input">
      <NumericInput
        placeholder="0"
        value={value}
        onChange={(val) => {
          handleChange(customField.id, val);
        }}
        onBlur={handleTouched}
      />
    </div>
  );
};

CustomLongField.propTypes = {
  value: PropTypes.any,
  customField: PropTypes.shape({
    id: PropTypes.number.isRequired,
    displayName: PropTypes.string.isRequired,
    dataType: PropTypes.string.isRequired,
    required: PropTypes.bool,
    uiControlType: PropTypes.string,
  }).isRequired,
  handleChange: PropTypes.func.isRequired,
  handleTouched: PropTypes.func,
};

export default CustomLongField;
